import useSWR from 'swr';

import { cookieUtils } from '@/utils/cookieUtils';
import { fetcher } from '@/utils/apiService';


export const useFormsList = () => {
    const token = cookieUtils.getAuthToken();

    const { data, error, isLoading, mutate } = useSWR(
        token ? '/documents/form-list' : null,
        fetcher,
        {
            onError: (err) => {
                console.error('Forms list fetch error:', err);
            }
        }
    );


    return {
        formsData: data?.data,
        isLoading,
        isError: error,
        mutate

    };
};
